import React from 'react';
import { motion } from 'framer-motion';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
}
export function PageHeader({
  title,
  subtitle
}: PageHeaderProps) {
  return <div className="relative pt-32 pb-20 bg-chocolate overflow-hidden" data-id="element-169">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-170" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold/10 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-171" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-172">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif text-cream mb-4" data-id="element-173">
          {title}
        </motion.h1>

        {subtitle && <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-lg text-cream/80 max-w-2xl mx-auto" data-id="element-174">
            {subtitle}
          </motion.p>}
      </div>
    </div>;
}